export const checklistItems = [{
    name: [
      "Consent / High risk consent", "Preparation of parts", "Surgical site Marked",
      "Jewels to be removed by the attender", "Hearing aid / Prosthesis / Denture / Contact Lens to be removed & given to attender",
      "Starvation from", "Bowel Preparation", "Investigation: X-Ray, ECG, CT Scan, Lab etc.",
      "Premedication", "Blood requirements: WB/PC/FFP/CP/Platslets", "Blood requirements units",
      "OT Dress, Cap, Leggings, Nail Polish removed", "Allergies", "Specify",
      "IV Fluids, Drugs, Disposables, Draw Sheet, Macintosh", "OT Drugs & Patient File handed over to OT Nurse",
      "Inj. TT / Test Dose / Antibiotics", "Case-Sheet / Investigations / Drugs", "Anti-Coagulation Drugs",
      "HBSAG / HCV / HIV (Serology)", "Bladder voided / Drainage", "Loose tooth / Dentures removed", "On any Medication - Specify",
    ],
    key: [
      "consent_high_risk", "preparation_of_parts", "surgical_site_marked",
      "jewels_removed", "hearing_aid_removed", "starvation_from", "bowel_preparation",
      "investigation_xray_ct_ecg", "premedication", "blood_requirements", "ot_dress_removed",
      "allergies", "specify", "iv_fluids_drugs_given", "ot_drugs_file_handed",
      "inj_tt_test_dose", "case_sheet_checked", "anti_coagulation", "hbsag_hcv_hiv",
      "bladder_voided", "loose_tooth_removed", "on_any_medication" // Note "blood_units" maps differently in form above this
    ],
    key2: [
      "consent_high_risk_remarks", "preparation_of_parts_remarks", "surgical_site_marked_remarks",
      "jewels_removed_remarks", "hearing_aid_removed_remarks", "starvation_from_remarks",
      "bowel_preparation_remarks", "investigation_xray_ct_ecg_remarks", "premedication_remarks",
      "blood_requirements_remarks", "ot_dress_removed_remarks", "allergies_remarks", "specify_remarks",
      "iv_fluids_drugs_given_remarks", "ot_drugs_file_handed_remarks", "inj_tt_test_dose_remarks",
      "case_sheet_checked_remarks", "anti_coagulation_remarks", "hbsag_hcv_hiv_remarks",
      "bladder_voided_remarks", "loose_tooth_removed_remarks", "on_any_medication_remarks"
    ]
}];

export const commonRemarks = [
  "Completed", "Not applicable", "Pending", "In progress", "To be done by nurse", "Verified", "Discuss with consultant"
];

export const specialItems = [{
  name: [
    "Epidural", "Central Line", "Feeding Jejunostomy", "Tracheostomy", "ICD", "Drain", "Ryle Tube"
  ],
  key: [
    "epidural", "central_line", "feeding_jejunostomy", "tracheostomy", "icd", "drain", "ryle_tube"
  ],
  key2: [
    "epidural_remarks", "central_line_remarks", "feeding_jejunostomy_remarks",
    "tracheostomy_remarks", "icd_remarks", "drain_remarks", "ryle_tube_remarks"
  ]
}];

export const doctorGroups = {
  Cardiologists: [
    "Dr. John Smith", "Dr. Emily Johnson", "Dr. Michael Brown", "Dr. Sarah Davis", "Dr. William Wilson", "Dr. Linda Martinez"
  ],
  Neurologists: [
    "Dr. Robert Lee", "Dr. Patricia Taylor", "Dr. James Anderson", "Dr. Barbara Thomas", "Dr. David Jackson", "Dr. Susan White"
  ],
  Orthopedics: [
    "Dr. Richard Garcia", "Dr. Jennifer Harris", "Dr. Charles Clark", "Dr. Jessica Lewis", "Dr. Thomas Robinson", "Dr. Karen Walker"
  ],
  Dermatologists: [
    "Dr. Nancy Young", "Dr. Matthew Hall", "Dr. Donna Allen", "Dr. Steven King", "Dr. Michelle Wright", "Dr. George Scott"
  ],
  Gynecologists: [
    "Dr. Sandra Green", "Dr. Kevin Adams", "Dr. Laura Baker", "Dr. Mark Nelson", "Dr. Angela Carter", "Dr. Brian Mitchell"
  ],
  Pediatricians: [
    "Dr. Melissa Perez", "Dr. Eric Roberts", "Dr. Deborah Turner", "Dr. Jason Phillips", "Dr. Rebecca Campbell", "Dr. Andrew Parker"
  ],
  AnaesthesiaSpecialists: [
    "Dr. Anil Mehta", "Dr. Priya Iyer", "Dr. Rakesh Nair", "Dr. Neha Sharma", "Dr. Vivek Rao", "Dr. Aarti Desai"
  ]
};

export const nurseGroups = {
  ICU: [
    "Nurse Anna Smith", "Nurse Brian Lee", "Nurse Carol White", "Nurse David Green", "Nurse Emma Black", "Nurse Frank Harris"
  ],
  Pediatrics: [
    "Nurse Emily Davis", "Nurse Frank Miller", "Nurse Grace Wilson", "Nurse Hannah Moore", "Nurse Ian Clark", "Nurse Julia Lewis"
  ],
  GeneralWard: [
    "Nurse Henry Brown", "Nurse Irene Clark", "Nurse Jack Harris", "Nurse Kelly Martinez", "Nurse Liam Thompson", "Nurse Mia Anderson"
  ],
  Emergency: [
    "Nurse Karen Scott", "Nurse Larry Adams", "Nurse Monica Turner", "Nurse Nathan Hill", "Nurse Olivia King", "Nurse Peter Wright"
  ],
  Surgery: [
    "Nurse Quinn Young", "Nurse Rachel Walker", "Nurse Samuel Hall", "Nurse Tina Allen", "Nurse Victor Baker", "Nurse Wendy Nelson"
  ],
  Maternity: [
    "Nurse Xavier Perez", "Nurse Yolanda Roberts", "Nurse Zoe Campbell", "Nurse Aaron Phillips", "Nurse Bethany Parker", "Nurse Chris Turner"
  ]
};

export const weightOptions = ["40 kg", "45 kg", "50 kg", "55 kg", "60 kg", "65 kg", "70 kg", "75 kg", "80 kg", "85 kg", "90 kg", "95 kg", "100 kg"];
export const bloodGroupOptions = ["A+", "A-", "B+", "B-", "AB+", "AB-", "O+", "O-"];
export const roomNoOptions = ["101", "102", "103", "201", "202", "203", "301", "302", "401", "ICU-1", "ICU-2"];
export const medicationOptions = ["Paracetamol", "Ibuprofen", "Amoxicillin", "Insulin", "Aspirin", "Metformin", "Omeprazole"];
export const diagnosisOptions = ["Hypertension", "Diabetes", "Asthma", "COVID-19", "Pneumonia", "Migraine", "Anemia"];
export const bowelPrepMedications = ["Polyethylene Glycol (PEG)", "Bisacodyl", "Sodium Phosphate", "Magnesium Citrate", "Senna", "Lactulose"];
